import 'babel-polyfill';
import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import CheckoutMain from './templates/CheckoutMain';
import CheckoutMainVIE from './templates/CheckoutMainVIE';
import colors from 'vuetify/es5/util/colors';
import AsyncComputed from 'vue-async-computed';
import Axios from 'axios';
import ADA from '../common/ada/ADA';
import './ada';

function reportJSError(err) {
	if (((new Date()) - reportJSError.lastErrorDate) < 10000) {
		return false;
	}
	reportJSError.lastErrorDate = new Date();
	let data = new FormData();
	data.set('url', window.location.href);
	data.set('msg', err.message ? err.message : err);
	data.set('stack', err.stack || null);
	data.set('row', err.lineNumber || 0);

	Axios({
		method: "post",
		url: "/tools/ajax/handle_js_error.php",
		data: data,
		config: {headers: {'Content-Type': 'multipart/form-data'}}
	});
}

Vue.config.errorHandler = function (err, vm, info) {
	console.error("Caught error", err);
	reportJSError(err);
};
window.onunhandledrejection = function (err) {
	console.error("Caught unhandled rejection", err.reason);
	reportJSError(err.reason ? err.reason : err);
};

const school_policy_tpl = document.getElementById('school-policies-tpl');

Vue.prototype.$eventHub = new Vue();
Vue.prototype.$globs = {...window.cfg, school_policy_tpl: school_policy_tpl ? school_policy_tpl.innerText : null};

Vue.prototype.$const = {
	STEP_LOGIN: 0,
	STEP_SHIPPING_ADDRESS: 1,
	STEP_TAX_EXEMPT: 2,
	STEP_SHIPPING_METHOD: 3,
	STEP_PAYMENT: 4,
	STEP_RECEIPT: 5,
};

Vue.prototype.stepGAEventNames = {
	0: 'step_0_checkout_login',
	1: 'step_1_checkout_shipping_address',
	2: 'step_2_checkout_tax_exempt',
	3: 'step_3_checkout_shipping_method',
	4: 'step_4_checkout_payment',
	5: 'step_5_checkout_receipt'
};

if (typeof sendFBPixelAction === 'function') {
	Vue.prototype.sendFBPixelAction = sendFBPixelAction;
}
if (typeof sendGAAction === 'function') {
	Vue.prototype.sendGAAction = sendGAAction;
}

Vue.use(AsyncComputed);

Vue.use(Vuetify, {
	theme: {
		accent: '#2170f2',
	},
});

Vue.use(ADA);

const app = new Vue({
	el: '#co-body',

	components: {
		'checkout-main': CheckoutMain,
		'checkout-main-vie': CheckoutMainVIE,
	},

	data() {
		return {
			loading: false,
		};
	},

	mounted() {
		this.init();
	},

	computed: {},

	methods: {
		init() {
			let self = this;

			self.$eventHub.$on('show-loader', () => {
				self.loading = true;
			});

			self.$eventHub.$on('hide-loader', () => {
				self.loading = false;
			});
		},
	},
});
